import Image from 'next/image'
import React from 'react'
import styled from 'styled-components'

import Container from '../../components/Container'
import { MEDIA_QUERY_DESKTOP } from '../../utils/media-query'

const Primary = styled.div`
  padding: 2rem 0;
  border-top: 1px solid rgba(255, 255, 255, .15);

  ${MEDIA_QUERY_DESKTOP} {
    padding: 4rem 0;
  }
`

const Secondary = styled.div`
  padding: 2rem 0;
  border-top: 1px solid rgba(255, 255, 255, .15);

  ${MEDIA_QUERY_DESKTOP} {
    padding: 4rem 0;
  }
`

const Content = styled.div``

const Description = styled.div`
  max-width: 620px;
  opacity: .5;
`

const Title = styled.h2`
  margin-bottom: .5rem;
`

const TeamMembers = styled.div`
  ${MEDIA_QUERY_DESKTOP} {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 3rem;
  }
`

const TeamMemberWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 3rem;

  ${MEDIA_QUERY_DESKTOP} {
    margin-bottom: 0;
  }
`

const TeamMemberImage = styled.div`
  img {
    border-radius: 9999px;
  }
`

const TeamMemberName = styled.div`
  margin-top: 1rem;
`

const TeamMemberTitle = styled.div`
  font-size: .75rem;
  color: rgba(255, 255, 255, .6);
`

const TeamMemberDescription = styled.div`
  font-size: 14px;
  margin-top: 1rem;
  color: rgba(255, 255, 255, .5);
  text-align: center;

  ${MEDIA_QUERY_DESKTOP} {
    height: 140px;
  }
`

const TeamMember = ({
  image,
  name,
  title,
  description
}) => {
  return (
    <TeamMemberWrap>
      <TeamMemberImage>
        {image}
      </TeamMemberImage>
      <TeamMemberName>
        {name}
      </TeamMemberName>
      <TeamMemberTitle>
        {title}
      </TeamMemberTitle>
      <TeamMemberDescription>
        {description}
      </TeamMemberDescription>
    </TeamMemberWrap>
  )
}

const IMAGE_SCALE = 1

const Team = () => {
  return (
    <>
      <Primary>
        <Container>
          <Content>
            <Title>
              Who are we?
            </Title>
            <Description>
              Hi! We're a small, dedicated team of makers, creatives, and music producers. We've worked with clients like Sony, The Orchard, Overloop, Mr. Bill, RTL, Nordic Blockchain Association and more.
              <br />
              <br />
              Our mission with Triptcip is to push the boundaries of what's possible with NFTs and move the (electronic) music industry to new frontiers. Welcome onboard!
            </Description>
          </Content>
        </Container>
      </Primary>
      <Secondary>
        <Container>
          <TeamMembers>
            <TeamMember
              name='Mike Vercoelen'
              image={(
                <Image
                  src='/images/team/mike.jpg'
                  alt='Mike Vercoelen'
                  width={185 * IMAGE_SCALE}
                  height={185 * IMAGE_SCALE}
                  quality={100}
                />
              )}
              title='Founder - Development, Design'
              description={(
                <>
                  Over 10 years of professional software development experience for clients like Sony, The Orchard, CleverTech and more. Also, founded two other music production related startups, Pitcch and Stereogate. Believes in simplicity, good taste, and effective planning.
                </>
              )}
            />
            <TeamMember
              name='Vince Smolders'
              image={(
                <Image
                  src='/images/team/vince.jpg'
                  alt='Vince Smolders'
                  width={185 * IMAGE_SCALE}
                  height={185 * IMAGE_SCALE}
                  quality={100}
                />
              )}
              title='Founder - Marketing'
              description={(
                <>
                  Digital marketing and business development since 2017. Highly experienced with brand & concept development. Running music production startups Pitcch and Stereogate. Discovering a blend of crypto and electronic music.
                </>
              )}
            />
            <TeamMember
              name='Arthur Yurchak'
              image={(
                <Image
                  src='/images/team/arthur.jpg'
                  alt='Arthur Yurchak'
                  width={185 * IMAGE_SCALE}
                  height={185 * IMAGE_SCALE}
                  quality={100}
                />
              )}
              title='Marketing, Community Building'
              description={(
                <>
                  Internet marketing multi-tool. Involved in blockchain space since 2016, working with Nordic Blockchain Association. Runs a marketing lab that helps startups find product-market fit. Recent music theory nerd.
                </>
              )}
            />
            <TeamMember
              name='Darren Otgaar'
              image={(
                <Image
                  src='/images/team/darren.jpg'
                  alt='Darren '
                  width={185 * IMAGE_SCALE}
                  height={185 * IMAGE_SCALE}
                  quality={100}
                />
              )}
              title='Development - 2D + 3D graphics'
              description={(
                <>
                  The brain and consultant behind Void's visual rendering system. Highly skilled computer graphics programmer with over 15+ years of industry experience.
                </>
              )}
            />
            <TeamMember
              name='Alyona Chervinska'
              image={(
                <Image
                  src='/images/team/alyona.jpg'
                  alt='Alyona Chervinska'
                  width={185 * IMAGE_SCALE}
                  height={185 * IMAGE_SCALE}
                  quality={100}
                />
              )}
              title='Digital Artist'
              description={(
                <>
                  Digital artist and graphic designer since 2014. Portrait, graphic, oil and wallet paint artist since childhold. Was born with a brush in her hand.
                </>
              )}
            />
            <TeamMember
              name='Nick Barry'
              image={(
                <Image
                  src='/images/team/nick.jpg'
                  alt='Nick Barry'
                  width={185 * IMAGE_SCALE}
                  height={185 * IMAGE_SCALE}
                  quality={100}
                />
              )}
              title='Development, Smart Contracts'
              description={(
                <>
                  Highly experienced Solidity developer, one of the main guys behind HardHat, one of Solidity's main projects. Involved as consultant for extra Solidity expertise.
                </>
              )}
            />
          </TeamMembers>
        </Container>
      </Secondary>
    </>
  )
}

export default Team
